import { render, staticRenderFns } from "./ServiceSupportList.vue?vue&type=template&id=35eacb47&"
import script from "./ServiceSupportList.vue?vue&type=script&lang=js&"
export * from "./ServiceSupportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports